import { createContext } from 'react';
import { StudentProfile } from '../../constants/types/student/profile/type';
type StudentProfileContextType = {
  studentProfile: StudentProfile | undefined;
  setStudentProfile: (studentProfile: StudentProfile) => void;
};

export const StudentProfileContext = createContext<StudentProfileContextType>({
  studentProfile: undefined,
  setStudentProfile: () => {},
});
